export const getButtonStyle = (
  style?:
    | "primary"
    | "secondary"
    | "cancel"
    | "accent"
    | "complementary"
    | "mixed"
    | "like"
    | "cta"
    | "green"
    | "outline"
    | "outline-complementary"
) => {
  switch (style) {
    case "primary":
      return "rounded-lg bg-blue-1 text-white hover:bg-blue-3";
    case "secondary":
      return "bg-blue-2 text-white border-blue-2 hover:bg-[#9B9DE9]";
    case "cancel":
      return "bg-gradient-to-t from-red-700 to-red-2 text-white border-transparent hover:from-red-2 hover:to-red-3";
    case "accent":
      return " bg-blue-4 text-darkGray-1 border-transparent hover:bg-[#DEE0F7]";
    case "complementary":
      return "bg-gradient-to-t from-orange-1 from-10% via-orange-1.5 via-45% to-orange-2.5 to-80% disabled:from-gray-1 disabled:to-gray-3 text-white border-none hover:from-orange-1.5 hover:to-orange-4";
    case "mixed":
      return "bg-gradient-to-r from-blue-5 from-45% via-orange-1 via-65% to-orange-2 to-85% shadow-lg disabled:from-orange-5 disabled:to-orange-6 disabled:text-orange-4 text-white border-none hover:from-orange-2 hover:to-orange-2.5 hover:shadow-xl";
    case "like":
      return "bg-white text-darkGray-1 border-darkGray-1 hover:bg-gray-3 hover:text-pink-1";
    case "cta":
      return "rounded-lg bg-gradient-to-r from-blue-5 to-blue-2 text-white hover:from-blue-1 hover:to-blue-3";
    case "green":
      return "rounded-lg bg-green-600 text-white hover:bg-green-500";
    case "outline":
      return "bg-white text-blue-1 border-blue-1 hover:bg-blue-4 disabled:bg-gray-4 disabled:text-gray-1 disabled:border-gray-1";
    case "outline-complementary":
      return "bg-white text-orange-1.5 border-orange-1.5 hover:bg-[#F08B2030] disabled:bg-gray-4 disabled:text-gray-1 disabled:border-gray-1";
    default:
      return "bg-white text-darkGray-1 border-darkGray-1 hover:bg-gray-3";
  }
};
